import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import {
  FaBullhorn,
  FaCheckCircle,
  FaExclamationTriangle,
  FaInfoCircle,
} from "react-icons/fa";

function getNoticeStyles(color) {
  switch ((color || "").toLowerCase()) {
    case "red":
      return {
        wrapper:
          "border-red-400/20 bg-red-500/10 text-red-100",
        icon: <FaExclamationTriangle className="shrink-0" />,
      };
    case "green":
      return {
        wrapper:
          "border-emerald-400/20 bg-emerald-500/10 text-emerald-100",
        icon: <FaCheckCircle className="shrink-0" />,
      };
    case "yellow":
      return {
        wrapper:
          "border-amber-300/20 bg-amber-400/10 text-amber-100",
        icon: <FaBullhorn className="shrink-0" />,
      };
    case "blue":
    default:
      return {
        wrapper:
          "border-cyan-300/20 bg-cyan-400/10 text-cyan-100",
        icon: <FaInfoCircle className="shrink-0" />,
      };
  }
}

export default function NoticeBar() {
  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const fetchNotice = async () => {
      const { data, error } = await supabase
        .from("notice_bar")
        .select("id, message, enabled, color")
        .eq("enabled", true)
        .order("updated_at", { ascending: false })
        .limit(1)
        .maybeSingle();

      if (!mounted) return;

      if (error) {
        console.error("Failed to load notice bar:", error);
        setNotice(null);
        setLoading(false);
        return;
      }

      setNotice(data || null);
      setLoading(false);
    };

    fetchNotice();

    const channel = supabase
      .channel("notice-bar-realtime")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "notice_bar" },
        () => {
          fetchNotice();
        },
      )
      .subscribe();

    return () => {
      mounted = false;
      supabase.removeChannel(channel);
    };
  }, []);

  if (loading || !notice?.enabled || !notice?.message) {
    return null;
  }

  const styles = getNoticeStyles(notice.color);

  return (
    <div
      className={`mb-6 flex items-start gap-3 rounded-2xl border px-4 py-4 text-sm ${styles.wrapper}`}
    >
      <div className="mt-0.5">{styles.icon}</div>
      <div className="leading-6">{notice.message}</div>
    </div>
  );
}